import PillFilterTabs from '@/components/PillFilterTabs'
import TableCoversByFilter from '@/modules/tableCovers/TableCoversByFilter'
import { TableCoversFilterKey } from '@/redux/slices/tableCoverSlice'
import { useAppSelector } from '@/redux/store'
import { useState } from 'react'
import { View } from 'react-native'

const FILTER_TABS: { key: TableCoversFilterKey; label: string }[] = [
  { key: TableCoversFilterKey.MyTables, label: '我的表格' },
  { key: TableCoversFilterKey.SharedTables, label: '与我共享' },
]

export default function TableCoversPage() {
  const currentUserLoaded = useAppSelector(state => state.currentUser.loaded)
  const currentUser = useAppSelector(state => state.currentUser.user)

  const [activeFilter, setActiveFilter] = useState(TableCoversFilterKey.MyTables)

  if (!currentUserLoaded || !currentUser) {
    return null
  }

  const listHeader = (
    <View>
      <PillFilterTabs tabs={FILTER_TABS} activeTag={activeFilter} onSelect={setActiveFilter} />
    </View>
  )

  return <TableCoversByFilter activeFilter={activeFilter} ListHeaderComponent={listHeader} />
}
